import { render, staticRenderFns } from "./MonthlyPTPTNSubmissionRecordEdit.vue?vue&type=template&id=a33550f0"
import script from "./MonthlyPTPTNSubmissionRecordEdit.vue?vue&type=script&lang=js"
export * from "./MonthlyPTPTNSubmissionRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports